module.exports = __webpack_public_path__ + "static/media/logo-lundbeck.c4da479c.png";


//////////////////
// WEBPACK FOOTER
// ./src/content/img/logo-lundbeck.png
// module id = 1481
// module chunks = 0